import { ObjectRegistry } from "./ObjectRegistry";
import { Class, Finder } from "./Base"
import { getTypeName } from '../domain';

class Context {

    private contextRegistry:ObjectRegistry;

    private _cacheRefresherFunc: Record<string, ()=>void> = {}

    constructor() {
        this.contextRegistry = new ObjectRegistry();
    }

    private static instance = new Context();

    static getInstance() {
        return Context.instance;
    }

    static createNewInstance() {
        Context.instance = new Context();
        return Context.getInstance();
    }

    registerFinder<T>(objectType: Class<T>, finder:Finder<T>) {
        const key = getTypeName(objectType) + "-registry";
        this.contextRegistry.put(objectType, key, finder);
    }

    registerCacheRefresh(uuid: string, refreshFunc : () => void) {
        this._cacheRefresherFunc[uuid] = refreshFunc;
    }

    triggerCacheRefresh(uuid: string) {
        const func = this._cacheRefresherFunc[uuid];
        if (func !== undefined) {
            func();
        }
    }

    getFinder<T> (objectType: Class<T>) : Finder<T> {
        const typeName = getTypeName(objectType);
        const finder = this.contextRegistry.get<T>(objectType, typeName + "-registry");
        if (!finder) {
            throw new Error("No finder defined for type " + typeName);
        }
        return finder;
    }
}
export {Context};